<template>
  <div class="lang-select">
    <span :class="{ active: language === 'zh' }" @click="handleSetLanguage('zh')">中文</span>
    <span>/</span>
    <span :class="{ active: language === 'en' }" @click="handleSetLanguage('en')">En</span>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  watch: {
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // this.$router.go(0)
      this.$emit('change', lang)
    }
  }
}
</script>
<style lang="scss" scoped>
.lang-select {
  font-size: 16px !important;
  display: inline-block;

  span {
    cursor: pointer;
    &.active {
      color: $primaryColor;
    }
    &:hover {
      color: #85BAE5;
    }
  }
}
</style>
